import { Observable } from "rxjs";

/**
 * Helper class for handling mobile download file responses.
 * It provides a method to handle the observable response from a download request.
 * If the response is successful, it creates a link element to download the file.
 * If an error occurs, it calls the provided error callback.
 */

export class MobileDownloadFileHelper {
  public static handleMobileObservableResponse(downloadObservable: Observable<any>, onError: () => void): void {
    downloadObservable.subscribe({
      next: (response: any) => {
        console.log(response);
        const link = document.createElement("a");
        link.href = response.redirect_url;
        link.target = "_self";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      error: (error: any) => {
        console.error("Error occurred:", error);
        onError(); // Wywołanie przekazanego callbacka przy błędzie
      }
    });
  }
}
